import { render } from "./VideoStreamControl.vue?vue&type=template&id=e5578826&scoped=true"
import script from "./VideoStreamControl.vue?vue&type=script&lang=js"
export * from "./VideoStreamControl.vue?vue&type=script&lang=js"

import "./VideoStreamControl.vue?vue&type=style&index=0&id=e5578826&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5578826"]])

export default __exports__